export const container = `
  p-4 flex justify-between items-center shadow-sm
  group-data-[is-expanded=false]/sidebar:justify-end
`;
export const icon = `w-5 h-5 mx-0.5 group-data-[is-expanded=false]/sidebar:rotate-180 transition-transform duration-200 delay-100 ease-in-out flex self-right`;
